import React from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { EmptyState, Delta } from "@/components/common";
import { fmtUSD } from "@/lib/format";
import { TrendingUp, TrendingDown, Trophy } from "lucide-react";

const Row = ({ h, positive }) => (
  <div className="flex items-center gap-3 rounded-lg border p-3" data-testid={`performer-${h.symbol}`}>
    <div className={`h-8 w-8 rounded-lg flex items-center justify-center shrink-0 ${positive ? "bg-emerald-500/15" : "bg-red-500/15"}`}>
      {positive ? <TrendingUp className="h-4 w-4 text-emerald-600" /> : <TrendingDown className="h-4 w-4 text-red-600" />}
    </div>
    <div className="min-w-0 flex-1">
      <div className="flex items-center gap-2">
        <span className="font-medium text-sm">{h.symbol}</span>
        <Badge variant="outline" className="text-[10px] capitalize">{h.asset_class}</Badge>
      </div>
      <div className="text-xs text-muted-foreground truncate">{h.name}</div>
    </div>
    <div className="text-end shrink-0">
      <div className="numeric text-sm font-semibold">{fmtUSD(h.value_usd)}</div>
      <Delta value={h.pnl_pct} />
    </div>
  </div>
);

export const PerformersPanel = ({ best = [], worst = [] }) => {
  if (!best.length) {
    return (
      <Card className="p-5 shadow-premium">
        <EmptyState title="No holdings yet"
          hint="Fund a portfolio or place a trade and your best performers will show up here."
          testid="performers-empty" />
      </Card>
    );
  }
  return (
    <div className="grid gap-4 sm:gap-5 md:grid-cols-2">
      <Card className="p-5 shadow-premium" data-testid="best-performers">
        <div className="flex items-center gap-2 text-sm font-medium mb-3"><Trophy className="h-4 w-4 text-[color:var(--tharwy-lime-700)]" />Best performers</div>
        <div className="space-y-2">{best.map((h, i) => <Row key={`${h.symbol}-${i}`} h={h} positive={h.pnl_pct >= 0} />)}</div>
      </Card>
      <Card className="p-5 shadow-premium" data-testid="worst-performers">
        <div className="flex items-center gap-2 text-sm font-medium mb-3"><TrendingDown className="h-4 w-4 text-muted-foreground" />Needs attention</div>
        {worst.length ? (
          <div className="space-y-2">{worst.map((h, i) => <Row key={`${h.symbol}-${i}`} h={h} positive={h.pnl_pct >= 0} />)}</div>
        ) : (
          <p className="text-sm text-muted-foreground">Nothing dragging on your portfolio right now.</p>
        )}
      </Card>
    </div>
  );
};
